import { render } from "./QtsSemanalShow.vue?vue&type=template&id=455a0690&scoped=true"
import script from "./QtsSemanalShow.vue?vue&type=script&lang=ts"
export * from "./QtsSemanalShow.vue?vue&type=script&lang=ts"

import "./QtsSemanalShow.vue?vue&type=style&index=0&id=455a0690&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-455a0690"

export default script